import axios from "axios";
import { getApiBaseUrl } from "../Email-Marketing/config/api";

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL, // First API
  withCredentials:true,
  // timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
});

const axiosClientSignIn = axios.create({
   baseURL: import.meta.env.VITE_API_BASE_URL_2 + '/maxadmin', 
  // timeout: 50000,
  withCredentials:true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosClientOrders = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL1, // First API
  withCredentials:true,
  // timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
});


export const axiosClientEmailMarketing = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosLogistics = axios.create({
  baseURL: import.meta.env.VITE_LOGISTICS_API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Default export (Main API)
export default axiosClient;

// Named export (Auth API)
export { axiosClientSignIn };
